<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.CustomsReceiptState')"
    :close-on-click-modal="false"
    :append-to-body="true"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :style="{width:'100%',height:'450px'}"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryCustomsInfoResLog } from '@/api/seaExport/customsInfo'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'CustomsInfoInteractResDialog',
  props: {
    visible: { type: Boolean, required: true },
    customsId: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ReceiptTime'),
          field: 'RECEIPT_DATE',
          suppressMenu: true,
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ReceiptContent'),
          field: 'RECEIPT_CONTENT',
          suppressMenu: true,
          width: 200
        }, {
          headerName: this.$t('SeaExport.ReceiveReceiptTime'),
          field: 'DATE_CREATED',
          suppressMenu: true,
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.receiptCode'),
          field: 'RECEIPT_CODE',
          suppressMenu: true,
          width: 200
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.customsId) {
        this.$message.warning(this.$t('Message.TheFormCannotBeEmpty'))
        return
      }
      queryCustomsInfoResLog({ customsId: this.customsId }).then(res => {
        this.rowData = res.data
      })
    }
  }
}
</script>

<style>
</style>
